import { Fragment } from 'react';
import { cn } from 'ui';

const BOLD_DELIMITER = '**';

// The copy of a note allows `**bold**` and nothing else; blank lines split
// paragraphs. Small enough to not need a markdown parser on every page.
const renderInline = (text: string) =>
  text.split(BOLD_DELIMITER).map((part, index) =>
    index % 2 ? (
      <strong key={index} className='font-semibold text-foreground'>
        {part}
      </strong>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    ),
  );

export const InlineText = ({ text }: { text: string }) => (
  <>{renderInline(text)}</>
);

export const RichText = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => (
  <>
    {text
      .split(/\n\s*\n/)
      .filter((paragraph) => paragraph.trim())
      .map((paragraph, index) => (
        <p key={index} className={cn('leading-relaxed', className)}>
          {renderInline(paragraph.trim())}
        </p>
      ))}
  </>
);
